export * from "./formatLink";
export * from "./toCapitalize";
export * from "./scrollTo";

export function yearsOfExperience(year: number = 2009) {
  return new Date().getFullYear() - year + 1;
}
